const BLOCK_ITEMS = [
    {
        type: "label",
        text: "Label",
        style: {
            fontSize: "16",
            fontWeight: "400",
        },
    },
    {
        type: "input",
        text: "Input",
        style: {
            fontSize: "16",
            fontWeight: "400",
        },
    },
    {
        type: "button",
        text: "Button",
        style: {
            fontSize: "16",
            fontWeight: "400",
        },
    },
];
export default BLOCK_ITEMS;
